import * as ko from "knockout";
import * as _ from "underscore";
import { App } from "../app";
import { Api } from "../app-api";
import { Cart } from "../app-cart";
import { ModeEnum } from "../app-models";

const divRoot: HTMLDivElement = document.querySelector("#ko-child");
const divModel: HTMLDivElement = document.querySelector("#divAccountChildModel");

export class ViewModel {
    id: number;
    dateOptions;
    mode: ModeEnum;

    busy = ko.observable(false);

    firstName = ko.observable<string>();
    lastName = ko.observable<string>();
    notes = ko.observable<string>();

    day = ko.observable("");
    year = ko.observable("");

    selectedGender = ko.observable<string>();
    selectedMonth = ko.observable<number>();

    editingFirstName = ko.observable(true);

    cart = ko.observable<Cart>(); // timer

    submit: () => void;

    constructor(model) {
        let self = this;

        let data = JSON.parse(model);

        self.mode = data.child ? ModeEnum.Edit : ModeEnum.Add;
        self.dateOptions = data.dateOptions;

        if (self.mode === ModeEnum.Edit)
            self.edit(data.child);

        if (data.cart) { self.cart(new Cart(data.cart, data.returnUrl)); }

        self.busy.subscribe(newVal => App.busy(newVal));

        self.firstName.subscribe(newVal => {
            if (self.mode == ModeEnum.Add &&
                App.hasVal(newVal) &&
                newVal.length > 0) { self.uniqueName(); }
        });

        self.submit = () => {
            if (!self.busy())
                self.save();
        }
    }

    private edit(child) {
        let self = this;

        self.id = child.id;
        self.firstName(child.firstName);
        self.lastName(child.lastName);
        self.notes(child.notes);

        let birthDate = child.birthDate;

        self.day(birthDate.day);
        self.year(birthDate.year);

        self.selectedMonth(birthDate.month);
        self.selectedGender(child.gender);
    }

    private save() {
        let self = this;

        self.busy(true);

        let data = self.toJson();

        Api.SaveChild(data)
            .done(results => {
                if (results.error) { return App.alertError(results.message); }
                if (!App.isValid(results.valid)) { return App.alertWarning(results.message); }
                //window.location.href = results.nextUrl;
                window.location.href = Api.GetUrl("account");
            })
            .always(() => self.busy(false));
    }

    
    private toJson() {
        let self = this;

        let data = {
            id: self.id,
            firstName: self.firstName(),
            lastName: self.lastName(),
            gender: self.selectedGender(),
            birthDate: {
                day: String(self.day()),
                month: String(self.selectedMonth()),
                year: String(self.year())
            },
            notes: self.notes()
        }

        return data;
    }

    private uniqueName() {
        let self = this;

        self.busy(true);

        let data = {
            firstName: self.firstName()
        };

        Api.UniqueChildName(data)
            .done(results => {
                if (results.error) { return App.alertError(results.message); }

                if (!App.isValid(results.valid))
                {
                    self.firstName("");
                    self.editingFirstName(true);
                    App.alertWarning(results.message);
                }
            })
            .always(() => self.busy(false));
    }
}

function init() {
    if (divModel) {
        ko.applyBindings(new ViewModel(divModel.textContent), divRoot);
    }
}

$(document).ready(() => init());